import React from "react";
import { LeaveRequest } from "../types/LeaveRequest";
import { Button, OverlayTrigger, Popover, Table } from "react-bootstrap";
import "../styles/EmployeeList.css";
import { CheckCircle, Edit, Trash } from "lucide-react";
import { useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { AuthUserType } from "../redux/actions/authUserActions";
import { XCircle } from "react-feather";
import { LocalFormatDate } from "../config/functions";

interface Props {
  leaveRequests: LeaveRequest[];
  onEdit: (request: LeaveRequest) => void;
  onDelete: (id: number) => void;
  onApprove: (request: LeaveRequest) => void;
  onCancel: (reques: LeaveRequest) => void;
}

const LeaveRequestList: React.FC<Props> = ({
  leaveRequests,
  onEdit,
  onDelete,
  onApprove,
  onCancel,
}) => {
  const authUser = useSelector<StoreState, AuthUserType>(
    (state) => state.authUser,
  );

  const filteredLeaveRequests =
    authUser.role === "Admin"
      ? leaveRequests
      : leaveRequests.filter((lr) => lr.employeeId === authUser.employeeId);

  const editPopover = (
    <Popover id="popover-edit">
      <Popover.Body>Edit Details</Popover.Body>
    </Popover>
  );
  const deletePopover = (
    <Popover id="popover-delete">
      <Popover.Body>Delete Details</Popover.Body>
    </Popover>
  );
  const approvePopover = (
    <Popover id="popover-approve">
      <Popover.Body>Approve Status</Popover.Body>
    </Popover>
  );

  return (
    <Table className="custom-employee-table" responsive>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Employee ID</th>
          <th>Year</th>
          <th>LeaveType</th>
          <th>Date Range</th>
          <th>Days</th>
          <th>Reason</th>
          <th>Status</th>
          <th>ApprovedBy</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {[...filteredLeaveRequests]
          .sort((a, b) => b.id - a.id)
          .map((lr, index) => {
            return (
              <tr key={lr.id}>
                <td>{index + 1}</td>
                <td>{lr.employeeId}</td>
                <td>{lr.year}</td>
                <td>{lr.leaveType}</td>
                <td>{LocalFormatDate(lr.dateList)}</td>
                <td>{lr.totalDays}</td>
                <td>{lr.reason}</td>
                <td>{lr.status}</td>
                <td>{lr.approvedBy}</td>
                <td>
                  {authUser.role === "Admin" && (
                    <>
                      <OverlayTrigger
                        trigger={["hover", "focus"]}
                        placement="top"
                        overlay={approvePopover}
                      >
                        <Button
                          className={`btn btn-sm text-white  ${lr.status === "Approved" ? "disabled-gray" : ""}`}
                          style={{
                            padding: "5px",
                            borderRadius: "5px",
                            marginRight: "5px",
                            border: "none",
                          }}
                          onClick={() => onApprove(lr)}
                          disabled={lr.status === "Approved"}
                        >
                          <CheckCircle
                            color="white"
                            style={{ width: "20px" }}
                          />
                        </Button>
                      </OverlayTrigger>
                      <OverlayTrigger
                        trigger={["hover", "focus"]}
                        placement="top"
                        overlay={approvePopover}
                      >
                        <Button
                          className="btn btn-sm text-white bg-danger"
                          style={{
                            padding: "5px",
                            borderRadius: "5px",
                            marginRight: "5px",
                            border: "none",
                          }}
                          onClick={() => onCancel(lr)}
                          disabled={lr.status === "Cancelled"}
                        >
                          <XCircle
                            // color="#dc3545"
                            style={{ width: "24px", cursor: "default" }}
                          />
                        </Button>
                      </OverlayTrigger>
                    </>
                  )}
                  {authUser.role === "User" && (
                    <>
                      <OverlayTrigger
                        trigger={["hover", "focus"]}
                        placement="top"
                        overlay={editPopover}
                      >
                        <Button
                          variant="success"
                          className={`btn btn-sm text-white bg-success ${lr.status === "Approved" ? "disabled-gray" : ""}`}
                          style={{
                            padding: "5px",
                            borderRadius: "5px",
                            marginRight: "5px",
                          }}
                          onClick={() => onEdit(lr)}
                          disabled={lr.status === "Approved"}
                        >
                          <Edit style={{ width: "20px" }} />
                        </Button>
                      </OverlayTrigger>
                      <OverlayTrigger
                        trigger={["hover", "focus"]}
                        placement="top"
                        overlay={deletePopover}
                      >
                        <Button
                          className={`btn btn-sm text-white bg-danger ${lr.status === "Approved" ? "disabled-gray" : ""}`}
                          style={{
                            padding: "5px",
                            borderRadius: "5px",
                            marginRight: "5px",
                            border: "none",
                          }}
                          onClick={() => onDelete(lr.id)}
                          disabled={
                            lr.status === "Approved" ||
                            lr.status === "Cancelled"
                          }
                        >
                          <Trash style={{ width: "20px" }} />
                        </Button>
                      </OverlayTrigger>
                    </>
                  )}
                </td>
              </tr>
            );
          })}
      </tbody>
    </Table>
  );
};
export default LeaveRequestList;
